<template >
  <div class="addResume">
    <el-form ref="form" :model="form" :rules="rules" label-width="100PX">
      <el-row>
        <el-col :span="5">
          <el-form-item label="任务名称" prop="task_name">
            <el-input v-model="form.task_name" placeholder="请输入任务名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="应聘者姓名" prop="applicant_name">
            <el-input v-model="form.applicant_name" placeholder="请输入应聘者姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="应聘者年龄" prop="age">
            <el-input v-model="form.age" placeholder="请输入应聘者年龄" type="number"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <el-form-item label="应聘部门" prop="applicant_section">
            <el-input v-model="form.applicant_section" placeholder="请选择应聘部门">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="应聘岗位" prop="position_applied">
            <el-input v-model="form.position_applied" placeholder="请选择应聘岗位">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="是否为高管">
            <el-radio-group v-model="form.task_tag">
              <el-radio label="1">是</el-radio>
              <el-radio label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <el-form-item label="最高学历" prop="highest_education">
            <el-input v-model="form.highest_education" placeholder="请选择最高学历">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="毕业院校" prop="graduate_school">
            <el-input v-model="form.graduate_school" placeholder="请选择毕业院校">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="毕业专业" prop="major">
            <el-input v-model="form.major" placeholder="请选择毕业专业">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="附件简历">
        <el-upload class="upload-demo" action="/index/V2.ScreenResumes/uploadResume" multiple :headers="headers"
          name="file" :on-success="uploadSuccess" :limit="1" :before-remove="removeUploadFile" :on-exceed="uploadExceed" accept=".pdf,.doc,.docx,.xsl">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传.pdf .doc .docx .xsl文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="任务时间">
        <el-date-picker v-model="time" type="daterange" range-separator="-" value-format="yyyy-MM-dd"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <div>简历评价人(每人奖励: 50元)</div> 
        <el-table :data="tableData" style="width: 600px" border stripe>
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>

          <el-table-column prop="realname" label="姓名" width="180">
          </el-table-column>
          <el-table-column prop="account" label="工号" width="180">
          </el-table-column>
          <el-table-column label="是否有奖金">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.is_bonus">
                <el-radio label="1">有</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <el-button @click="dialogVisible = true">新增人员</el-button>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">发布</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="新增人员" :visible.sync="dialogVisible" width="30%" @close="dialogClose">
      <el-form label-width="40px">
        <el-form-item label="姓名">
          <el-input v-model="keywords" placeholder="请输入内容" @input="search"></el-input>
        </el-form-item>
        <el-form-item label="工号">
          <template>
            <el-select v-model="user" value-key="uid" placeholder="请选择">
              <el-option v-for="item in JobNumberList" :label="item.realname + item.account" :value="item"
                :key="item.uid">
              </el-option>
            </el-select>
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addJobNumer">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { creationResumeApi, searchJobNumberApi } from "@/api/api/resume";
import { rules } from "./js/addResumeRules";
import Cookie from 'js-cookie'
export default {
  data() {
    return {
      rules,
      form: {
        task_name: "", //任务名
        task_tag: "2", //1高管2非高管
        applicant_name: "", //应聘者名字
        applicant_section: "", //应聘部门
        position_applied: "", //应聘职位
        highest_education: "", //学历
        graduate_school: "", //学校
        major: "", //专业
        age: "", //年龄
        screen_job_number_list: [], //筛选人
        accessory_url: "", //简历附件URL
        screen_start_time: "2022-05-19", //开始时间
        screen_end_time: "2022-05-21", //结束时间
      },
      time: null,
      tableData: [],
      dialogVisible: false,
      keywords: "",
      JobNumberList: [],
      user: "",
      headers: {
        token: Cookie.get('token')
      }
    };
  },
  created() { },
  methods: {
    dialogClose() {
      this.keywords = "";
      this.JobNumberList = [];
      this.user = "";
    },
    async search() {
      if (!this.keywords) {
        return;
      }
      let res = await searchJobNumberApi(this.keywords);
      console.log(res);
      this.JobNumberList = res.data.data;
    },
    addJobNumer() {
      if (!this.user) {
        return this.$message.error("请选择人员");
      }
      console.log(this.user);
      let flag = false;
      this.tableData.forEach((item) => {
        if (item.uid == this.user.uid) {
          flag = true;
        }
      });
      if (flag) {
        return this.$message.error("重复添加");
      }
      let item = {
        ...this.user,
        is_bonus: "2",
      };
      this.tableData.push(item);
      this.dialogVisible = false;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    uploadSuccess(res) {
      console.log(111, res);
      if (res.errorCode == 0) {
        this.form.accessory_url = res.data
      }
    },
    removeUploadFile() {
      this.form.accessory_url = ''
    },
    uploadExceed() {
        this.$message.warning('只可上传一个文件，请删除已上传文件后重试')
    },
    async submit() {
      console.log(this.time);
      if (!this.time) {
        return this.$message.error("请选择任务时间");
      }
      if (!this.form.accessory_url) {
        return this.$message.error("请上传简历附件");
      }
      if (!this.tableData.length) {
        return this.$message.error("请添加简历评价人");
      }
      let params = this.form;
      params.screen_job_number_list = this.tableData.map((item) => {
        return {
          uid: item.uid,
          is_bonus: item.is_bonus,
        };
      });
      params.screen_start_time = this.time[0];
      params.screen_end_time = this.time[1];
      console.log(params);
      let res = await creationResumeApi(params);
      if (res.data.errorCode == 0) {
        this.$message.success("发布成功");
        this.$router.back()
      }
    },
  },
};
</script>
<style>
.addResume {
  padding: 30px;
  font-size: 14px;
}
</style>